module.exports = __webpack_public_path__ + "img/analogous.a4ce4432.jpg";